import { Link, NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "Home / New Testament" },
  { to: "/old-testament", label: "Old Testament" },
  { to: "/about", label: "About" },
  { to: "/commentators", label: "Commentators" },
  { to: "/notes", label: "Transcriber's Notes" },
  { to: "/ebooks", label: "Free E-Books" },
  { to: "/contact", label: "Contact" },
];

export default function SiteHeader() {
  return (
    <header
      className="no-print"
      data-testid="site-header"
      style={{
        borderBottom: "1px solid var(--rule)",
        background:
          "linear-gradient(180deg, rgba(255,250,230,0.7), rgba(243,232,207,0.4))",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 pt-7 pb-5">
        <Link
          to="/"
          data-testid="site-title-link"
          className="block text-center group"
          style={{ color: "var(--ink)" }}
        >
          <div
            style={{
              fontFamily: "'IM Fell English SC', serif",
              fontSize: "0.78rem",
              letterSpacing: "0.45em",
              color: "var(--ink-muted)",
            }}
          >
            QUIDVERUM &middot; SCRIPTORIUM
          </div>
          <h1
            className="mt-1"
            style={{
              fontSize: "clamp(1.9rem, 4vw, 2.9rem)",
              lineHeight: 1.15,
              margin: 0,
            }}
          >
            Haydock&rsquo;s Catholic Bible Commentary
          </h1>
          <div
            style={{
              fontFamily: "'IM Fell English', serif",
              fontStyle: "italic",
              color: "var(--ink-soft)",
              fontSize: "1.05rem",
              marginTop: "0.35rem",
            }}
          >
            The 1859 Edition &mdash; Douay&ndash;Rheims with the Notes of the Fathers
          </div>
        </Link>

        <div className="ornament mt-5" aria-hidden>
          <span>&#10086;</span>
        </div>

        <nav
          className="top-nav mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2"
          data-testid="site-nav"
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.replace(/\//g, "") || "home"}`}
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
